import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ImportarDadosBancariosService } from '@services/importar-dados-bancarios.service';
import { take } from 'rxjs/operators';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-concluir-importacao-dados-bancarios',
    templateUrl: './concluir-importacao-dados-bancarios.component.html',
    styleUrls: ['./concluir-importacao-dados-bancarios.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, BreadcrumbComponent, RouterLink, FooterComponent, CnpjPipe]
})
export class ConcluirImportacaoDadosBancariosComponent implements OnInit {

  public loadingGenerico: boolean = false;
  public empresa: any = localStorage.idEmpresaLogada;

  public alertSucessoSubtitulo: any = 'Sucesso !';
  public alertSucessoMensagem: any = 'Senha adicionada com sucesso.';
  public alertSucesso: boolean = false;

  public alertErroSubtitulo: any = 'Erro ao adicionar arquivo !';
  public alertErroMensagem: string = '';
  public erro: boolean = false;

  constructor(
    public importarDadosBancariosService: ImportarDadosBancariosService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    if (!this.importarDadosBancariosService.ImportacaoDadosBancariosVO) {
      this.router.navigate(['/importar-dados-bancarios']);
    }
  }

  public enviarDadosSalvar() {
    this.loadingGenerico = true;
    this.importarDadosBancariosService.salvarImportacao(this.empresa, this.importarDadosBancariosService.ImportacaoDadosBancariosVO.response.importacaoDadosBancarios)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.loadingGenerico = false;
        this.alertSucesso = true;
        this.alertSucessoMensagem = success.mensagem;
      },
      error: (error: any) => {
        this.loadingGenerico = false;
        this.alertErroMensagem = error.error.mensagem;
        this.erro = true;
        this.alertSucesso = false;
      }
    });
  }

  public fecharAlertSucesso() {
    this.alertSucesso = false;
    this.router.navigate(['/importar-dados-bancarios']);
  }

  public fecharAlertErro() {
    this.erro = false;
    this.router.navigate(['/importar-dados-bancarios']);
  }
}
